"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultCryptoProvider = void 0;
const lang_1 = require("../lang");
const Logger_1 = require("./Logger");
class DefaultCryptoProvider {
    constructor() {
        this.loadCryptoFromEnvironment();
    }
    randomBytes() {
        if (this.cryptoProvider) {
            if (typeof this.cryptoProvider.randomBytes === 'function') {
                try {
                    return (this.cryptoProvider.randomBytes(Uint32Array.BYTES_PER_ELEMENT));
                }
                catch (err) {
                }
            }
        }
        Logger_1.logger.warn(lang_1.Language.strings.crypto.CryptoNotAvailableUsingMath);
        const randomBytes = Buffer.alloc(31 * Uint32Array.BYTES_PER_ELEMENT, Math.floor(Math.random() * 4294967295) >>> 0);
        return randomBytes;
    }
    randomInt(max) {
        return Math.floor((this.randomBytes().readUInt32LE() / 0xffffffff) * max);
    }
    ignoreCrypto() {
        this.cryptoProvider = undefined;
    }
    loadCryptoFromEnvironment() {
        if (!this.cryptoProvider &&
            typeof global !== 'undefined' &&
            global.crypto) {
            this.cryptoProvider = global.crypto;
        }
        if (!this.cryptoProvider && typeof require === 'function') {
            try {
                this.cryptoProvider = require('crypto');
            }
            catch (error) {
            }
        }
        if (!this.cryptoProvider) {
            Logger_1.logger.warn(lang_1.Language.strings.crypto.CryptoNotAvailable);
        }
    }
}
exports.DefaultCryptoProvider = DefaultCryptoProvider;
//# sourceMappingURL=CryptoProvider.js.map